<template>
  <div class ="program">
    <Title title="プログラム" color="#FD9473"/>
      <table>
        <tr><td class="time">7:10</td><td class="event">開会式</td></tr>
        <tr><td class="time">7:50</td><td class="event">俵取り（中3）<button v-on:click ="click3"><img src="/static/arrow.svg"></button></td></tr>
        <tr><td class="time">8:40</td><td class="event">馬上鉢巻取り（中1）<button v-on:click ="click1"><img src="/static/arrow.svg"></button></td></tr>
        <tr><td class="time">9:50</td><td class="event">学年別リレー（中学個人）<br>スウェーデンリレー（高校個人）</td></tr>
        <tr><td class="time">10:35</td><td class="event">棒倒し（高2）<button v-on:click ="click5"><img src="/static/arrow.svg"></button></td></tr>
        <tr><td class="time">11:40</td><td class="event">昼休み</td></tr>
        <tr><td class="time">11:50</td><td class="event">綱取り（中2）<button v-on:click ="click2"><img src="/static/arrow.svg"></button></td></tr>
        <tr><td class="time">12:45</td><td class="event">騎馬戦（高1）<button v-on:click ="click4"><img src="/static/arrow.svg"></button></td></tr>
        <tr><td class="time">13:55</td><td class="event">要領次第（中学個人）</td></tr>
        <tr><td class="time">14:10</td><td class="event">棒倒し（高3）<button v-on:click ="click6"><img src="/static/arrow.svg"></button></td></tr>
        <tr><td class="time">15:50</td><td class="event">全学年リレー</td></tr>
        <tr><td class="time">16:20</td><td class="event">閉会式</td></tr>
        <tr><td class="time">17:00</td><td class="event">完全撤収</td></tr>
      </table>
      <div id="screen">
        <transition mode="out-in">
        <div id="eve1" v-if= "show1" key="eve1">
          <Title title="馬上鉢巻取り(中一) 対戦表" color="#FD9473"/>
          <svg data-name="レイヤー 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 276 135.78"><polyline class="cls-1" points="12.32 111.89 12.32 84.89 48.32 84.89 48.32 111.89"/><polyline class="cls-1" points="228.32 111.89 228.32 84.89 264.32 84.89 264.32 111.89"/><polyline class="cls-1" points="156.32 111.89 156.32 84.89 192.32 84.89 192.32 111.89"/><polyline class="cls-1" points="84.32 111.89 84.32 84.89 120.32 84.89 120.32 111.89"/><polyline class="cls-1" points="30 84.89 30 57.89 101.68 57.89 101.68 84.89"/><polyline class="cls-1" points="174 84.89 174 57.89 246 57.89 246 84.89"/><polyline class="cls-1" points="66 57.89 66 30.89 209.68 30.89 209.68 57.89"/><line class="cls-1" x1="138" y1="3.89" x2="138" y2="30.89"/><text class="cls-2" transform="translate(130.5 48.78)">⑦</text><text class="cls-2" transform="translate(22.5 102.78)">①</text><text class="cls-2" transform="translate(238.5 102.78)">④</text><text class="cls-2" transform="translate(166.5 102.78)">③</text><text class="cls-2" transform="translate(202.5 75.78)">⑥</text><text class="cls-2" transform="translate(94.5 102.78)">②</text><text class="cls-2" transform="translate(58.5 75.78)">⑤</text><text class="cls-3" transform="translate(0 134.89)">緑</text><text class="cls-3" transform="translate(36 134.89)">黒</text><text class="cls-3" transform="translate(72 134.89)">赤</text><text class="cls-3" transform="translate(252 134.89)">青</text><text class="cls-3" transform="translate(216 134.89)">黄</text><text class="cls-3" transform="translate(180 134.89)">橙</text><text class="cls-3" transform="translate(144 134.89)">紫</text><text class="cls-3" transform="translate(108 134.89)">白</text><text x="0.51" y="-5.11"/><text class="cls-4" transform="translate(21 35.89)">田端側</text><text class="cls-4" transform="translate(217.21 35.89)">日暮里側</text></svg>
        </div>

        <div id="eve2" v-if= "show2" key="eve2">
          <Title title="綱取り(中二)対戦表" color="#FD9473"/>
          <svg v-if ="show2" data-name="レイヤー 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 276 135.78"><polyline class="cls-1" points="12.32 109.5 12.32 82.5 48.32 82.5 48.32 109.5"/><polyline class="cls-1" points="228.32 109.5 228.32 82.5 264.32 82.5 264.32 109.5"/><polyline class="cls-1" points="156.32 109.5 156.32 82.5 192.32 82.5 192.32 109.5"/><polyline class="cls-1" points="84.32 109.5 84.32 82.5 120.32 82.5 120.32 109.5"/><polyline class="cls-1" points="30 82.5 30 55.5 101.68 55.5 101.68 82.5"/><polyline class="cls-1" points="174 82.5 174 55.5 246 55.5 246 82.5"/><polyline class="cls-1" points="66 55.5 66 28.5 209.68 28.5 209.68 55.5"/><line class="cls-1" x1="138" y1="1.5" x2="138" y2="28.5"/><text class="cls-2" transform="translate(130.5 46.39)">⑦</text><text class="cls-2" transform="translate(22.5 100.39)">①</text><text class="cls-2" transform="translate(238.5 100.39)">④</text><text class="cls-2" transform="translate(166.5 100.39)">③</text><text class="cls-2" transform="translate(202.5 73.39)">⑥</text><text class="cls-2" transform="translate(94.5 100.39)">②</text><text class="cls-2" transform="translate(58.5 73.39)">⑤</text><text class="cls-3" transform="translate(0 132.5)">白</text><text class="cls-3" transform="translate(36 132.5)">赤</text><text class="cls-3" transform="translate(72 132.5)">黒</text><text class="cls-3" transform="translate(252 132.5)">緑</text><text class="cls-3" transform="translate(216 132.5)">黄</text><text class="cls-3" transform="translate(180 132.5)">橙</text><text class="cls-3" transform="translate(144 132.5)">紫</text><text class="cls-3" transform="translate(108 132.5)">青</text><text x="0.51" y="-7.5"/><text class="cls-4" transform="translate(21 33.5)">田端側</text><text class="cls-4" transform="translate(217.21 33.5)">日暮里側</text></svg>
        </div>

        <div id="eve3" v-if= "show3" key="eve3">
          <Title title="俵取り(中三)対戦表" color="#FD9473"/>
          <svg v-if ="show3" data-name="レイヤー 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 276 135.78"><polyline class="cls-1" points="12.32 109.5 12.32 82.5 48.32 82.5 48.32 109.5"/><polyline class="cls-1" points="228.32 109.5 228.32 82.5 264.32 82.5 264.32 109.5"/><polyline class="cls-1" points="156.32 109.5 156.32 82.5 192.32 82.5 192.32 109.5"/><polyline class="cls-1" points="84.32 109.5 84.32 82.5 120.32 82.5 120.32 109.5"/><polyline class="cls-1" points="30 82.5 30 55.5 101.68 55.5 101.68 82.5"/><polyline class="cls-1" points="174 82.5 174 55.5 246 55.5 246 82.5"/><polyline class="cls-1" points="66 55.5 66 28.5 209.68 28.5 209.68 55.5"/><line class="cls-1" x1="138" y1="1.5" x2="138" y2="28.5"/><text class="cls-2" transform="translate(130.5 46.39)">⑦</text><text class="cls-2" transform="translate(22.5 100.39)">①</text><text class="cls-2" transform="translate(238.5 100.39)">④</text><text class="cls-2" transform="translate(166.5 100.39)">③</text><text class="cls-2" transform="translate(202.5 73.39)">⑥</text><text class="cls-2" transform="translate(94.5 100.39)">②</text><text class="cls-2" transform="translate(58.5 73.39)">⑤</text><text class="cls-3" transform="translate(0 132.5)">青</text><text class="cls-3" transform="translate(36 132.5)">黄</text><text class="cls-3" transform="translate(72 132.5)">紫</text><text class="cls-3" transform="translate(252 132.5)">緑</text><text class="cls-3" transform="translate(216 132.5)">橙</text><text class="cls-3" transform="translate(180 132.5)">赤</text><text class="cls-3" transform="translate(144 132.5)">黒</text><text class="cls-3" transform="translate(108 132.5)">白</text><text class="cls-4" transform="translate(21 33.5)">田端側</text><text class="cls-4" transform="translate(217.21 33.5)">日暮里側</text></svg>
        </div>

        <div id="eve4" v-if= "show4" key="eve4">
          <Title title="騎馬戦(高一)対戦表" color="#FD9473"/>
          <svg v-if ="show4" data-name="レイヤー 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 276 135.78"><polyline class="cls-1" points="12.32 109.5 12.32 82.5 48.32 82.5 48.32 109.5"/><polyline class="cls-1" points="228.32 109.5 228.32 82.5 264.32 82.5 264.32 109.5"/><polyline class="cls-1" points="156.32 109.5 156.32 82.5 192.32 82.5 192.32 109.5"/><polyline class="cls-1" points="84.32 109.5 84.32 82.5 120.32 82.5 120.32 109.5"/><polyline class="cls-1" points="30 82.5 30 55.5 101.68 55.5 101.68 82.5"/><polyline class="cls-1" points="174 82.5 174 55.5 246 55.5 246 82.5"/><polyline class="cls-1" points="66 55.5 66 28.5 209.68 28.5 209.68 55.5"/><line class="cls-1" x1="138" y1="1.5" x2="138" y2="28.5"/><text class="cls-2" transform="translate(130.5 46.39)">⑦</text><text class="cls-2" transform="translate(22.5 100.39)">①</text><text class="cls-2" transform="translate(238.5 100.39)">④</text><text class="cls-2" transform="translate(166.5 100.39)">③</text><text class="cls-2" transform="translate(202.5 73.39)">⑥</text><text class="cls-2" transform="translate(94.5 100.39)">②</text><text class="cls-2" transform="translate(58.5 73.39)">⑤</text><text class="cls-3" transform="translate(0 132.5)">緑</text><text class="cls-3" transform="translate(36 132.5)">赤</text><text class="cls-3" transform="translate(72 132.5)">青</text><text class="cls-3" transform="translate(252 132.5)">黄</text><text class="cls-3" transform="translate(216 132.5)">橙</text><text class="cls-3" transform="translate(180 132.5)">黒</text><text class="cls-3" transform="translate(144 132.5)">紫</text><text class="cls-3" transform="translate(108 132.5)">白</text><text class="cls-4" transform="translate(21 33.5)">田端側</text><text class="cls-4" transform="translate(217.21 33.5)">日暮里側</text></svg>
        </div>

        <div id="eve5" v-if= "show5" key="eve5">
          <Title title="棒倒し(高二)対戦表" color="#FD9473"/>
          <svg  v-if = "show5" data-name="レイヤー 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 276 135.78"><polyline class="cls-1" points="12.32 109.5 12.32 82.5 48.32 82.5 48.32 109.5"/><polyline class="cls-1" points="228.32 109.5 228.32 82.5 264.32 82.5 264.32 109.5"/><polyline class="cls-1" points="156.32 109.5 156.32 82.5 192.32 82.5 192.32 109.5"/><polyline class="cls-1" points="84.32 109.5 84.32 82.5 120.32 82.5 120.32 109.5"/><polyline class="cls-1" points="30 82.5 30 55.5 101.68 55.5 101.68 82.5"/><polyline class="cls-1" points="174 82.5 174 55.5 246 55.5 246 82.5"/><polyline class="cls-1" points="66 55.5 66 28.5 209.68 28.5 209.68 55.5"/><line class="cls-1" x1="138" y1="1.5" x2="138" y2="28.5"/><text class="cls-2" transform="translate(130.5 46.39)">⑦</text><text class="cls-2" transform="translate(22.5 100.39)">①</text><text class="cls-2" transform="translate(238.5 100.39)">④</text><text class="cls-2" transform="translate(166.5 100.39)">③</text><text class="cls-2" transform="translate(202.5 73.39)">⑥</text><text class="cls-2" transform="translate(94.5 100.39)">②</text><text class="cls-2" transform="translate(58.5 73.39)">⑤</text><text class="cls-3" transform="translate(0 132.5)">橙</text><text class="cls-3" transform="translate(36 132.5)">黒</text><text class="cls-3" transform="translate(72 132.5)">緑</text><text class="cls-3" transform="translate(252 132.5)">紫</text><text class="cls-3" transform="translate(216 132.5)">青</text><text class="cls-3" transform="translate(180 132.5)">赤</text><text class="cls-3" transform="translate(144 132.5)">白</text><text class="cls-3" transform="translate(108 132.5)">黄</text><text class="cls-4" transform="translate(21 33.5)">田端側</text><text class="cls-4" transform="translate(217.21 33.5)">日暮里側</text><text x="0.51" y="-7.5"/></svg>
        </div>

        <div id="eve6" v-if= "show6" key="eve6">
          <Title title="棒倒し(高三)対戦表" color="#FD9473"/>
          <svg  v-if ="show6" data-name="レイヤー 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 276 192.06"><polyline class="cls-1" points="12.32 136.56 12.32 109.56 48.32 109.56 48.32 136.56"/><polyline class="cls-1" points="228.32 136.56 228.32 109.56 264.32 109.56 264.32 136.56"/><polyline class="cls-1" points="156.32 136.56 156.32 109.56 192.32 109.56 192.32 136.56"/><polyline class="cls-1" points="84.32 136.56 84.32 109.56 120.32 109.56 120.32 136.56"/><polyline class="cls-1" points="30 109.56 30 82.56 101.68 82.56 101.68 109.56"/><polyline class="cls-1" points="174 109.56 174 82.56 246 82.56 246 109.56"/><polyline class="cls-1" points="66 82.56 66 55.56 209.68 55.56 209.68 82.56"/><line class="cls-1" x1="138" y1="28.56" x2="138" y2="55.56"/><text class="cls-2" transform="translate(130.5 73.45)">⑩</text><text class="cls-2" transform="translate(22.5 127.45)">①</text><text class="cls-2" transform="translate(238.5 127.45)">④</text><text class="cls-2" transform="translate(166.5 127.45)">③</text><text class="cls-2" transform="translate(211.5 100.45)">⑧</text><text class="cls-2" transform="translate(94.5 127.45)">②</text><text class="cls-2" transform="translate(49.5 100.45)">⑦</text><text class="cls-3" transform="translate(0 159.56)">青</text><text class="cls-3" transform="translate(36 159.56)">橙</text><text class="cls-3" transform="translate(72 159.56)">赤</text><text class="cls-3" transform="translate(252 159.56)">白</text><text class="cls-3" transform="translate(216 159.56)">黒</text><text class="cls-3" transform="translate(180 159.56)">緑</text><text class="cls-3" transform="translate(144 159.56)">黄</text><text class="cls-3" transform="translate(108 159.56)">紫</text><line class="cls-4" x1="202.42" y1="82.56" x2="202.42" y2="84.06"/><line class="cls-5" x1="202.42" y1="87.06" x2="202.42" y2="97.56"/><polyline class="cls-4" points="202.42 99.06 202.42 100.56 200.92 100.56"/><line class="cls-6" x1="197.85" y1="100.56" x2="76.62" y2="100.56"/><polyline class="cls-4" points="75.08 100.56 73.58 100.56 73.58 99.06"/><line class="cls-5" x1="73.58" y1="96.06" x2="73.58" y2="85.56"/><line class="cls-4" x1="73.58" y1="84.06" x2="73.58" y2="82.56"/><line class="cls-7" x1="102" y1="163.56" x2="102" y2="165.06"/><line class="cls-8" x1="102" y1="167.73" x2="102" y2="187.73"/><polyline class="cls-7" points="102 189.06 102 190.56 100.5 190.56"/><line class="cls-9" x1="97.5" y1="190.56" x2="33" y2="190.56"/><polyline class="cls-7" points="31.5 190.56 30 190.56 30 189.06"/><line class="cls-8" x1="30" y1="186.39" x2="30" y2="166.39"/><line class="cls-7" x1="30" y1="165.06" x2="30" y2="163.56"/><line class="cls-7" x1="246" y1="163.56" x2="246" y2="165.06"/><line class="cls-8" x1="246" y1="167.73" x2="246" y2="187.73"/><polyline class="cls-7" points="246 189.06 246 190.56 244.5 190.56"/><line class="cls-9" x1="241.5" y1="190.56" x2="177" y2="190.56"/><polyline class="cls-7" points="175.5 190.56 174 190.56 174 189.06"/><line class="cls-8" x1="174" y1="186.39" x2="174" y2="166.39"/><line class="cls-7" x1="174" y1="165.06" x2="174" y2="163.56"/><text class="cls-2" transform="translate(58.5 181.45)">⑤</text><text class="cls-2" transform="translate(202.5 181.45)">⑥</text><text x="0.51" y="19.56"/><text class="cls-10" transform="translate(21 60.56)">田端側</text><text class="cls-10" transform="translate(217.21 60.56)">日暮里側</text><text class="cls-2" transform="translate(130.5 115.97)">⑨</text></svg>
        </div>
        </transition>
      </div>

  </div>
</template>

<style scoped>
  .program{
    scroll-behavior: smooth;
    position: relative;
    padding-top: 100px;
    padding-bottom: 50px;
    background-color: #4696CF;
  }
  .cls-1{
    fill:none;stroke:#fff; stroke-linecap:round;stroke-linejoin:round;stroke-width:3px;
   }
  .cls-2{
    font-size:15px;
  }
  .cls-2,.cls-3,.cls-4{
      fill:#fff;font-family: "Hiragino Kaku Gothic","游ゴシック Medium","Yu Gothic Medium","游ゴシック","Yu Gothic","游ゴシック体", "meiryo", sans-serif;
  }
  .cls-3{
    font-size:24px;
  }
  .cls-4{
    font-size:12px;
  }
  #eve6 .cls-1, #eve6 .cls-4, #eve6 .cls-5, #eve6 .cls-6, #eve6 .cls-7,#eve6 .cls-8,#eve6 .cls-9{
    fill:none;stroke:#fff;stroke-width:3px;
    }
  #eve6  .cls-1{
      stroke-linecap:round;stroke-linejoin:round;
    }
  #eve6  .cls-2{
      font-size:15px;
    }
  #eve6  .cls-10,.cls-2,.cls-3{
      fill:#fff;
      font-family: "Hiragino Kaku Gothic","游ゴシック Medium","Yu Gothic Medium","游ゴシック","Yu Gothic","游ゴシック体", "meiryo", sans-serif;
    }
  #eve6  .cls-3{
      font-size:24px;
    }
  #eve6 .cls-4,.cls-5,.cls-6{
      stroke-miterlimit:10;
    }
  #eve6  .cls-5,.cls-9{
      stroke-dasharray:3 3;
    }
  #eve6  .cls-6{
      stroke-dasharray:3.07 3.07;
    }
  #eve6  .cls-8{
      stroke-dasharray:2.67 2.67;
    }
  #eve6  .cls-10{
      font-size:12px;
    }
  .v-enter {
    opacity: 0;
  }
  .v-enter-active {
    transition: opacity 0.5s;
  }
  .v-enter-to {
      opacity: 1;
  }
  .v-leave{
    opacity: 0;
  }
  .v-leave-active{
    transition: opacity 0.5s;
  }
  .v-leave-to{
    opacity: 0;
  }


  table{
    font-size: 16px;
    margin-left: 100px;
    margin-right: auto;
    border-collapse:collapse;
    border-top: 2px solid #fff;
    border-bottom: 2px solid #fff;
    color: transparent;
    background-clip: text;
    -webkit-background-clip: text;
    background-image: linear-gradient(#ADADAD 50%, #FFFFFF 50%);
    background-repeat: no-repeat;
  }
  table tr td {
    padding: 10px 40px;
    border-left: 2px solid #fff;
    border-right: 2px solid #fff;
    font-weight: bold;
    color: #fff;
    z-index: 1;
  }
  .event{
    text-align: left;
  }
  .time{
    text-align: center;
  }

  button{
    position: relative;
    top: 5px;
    left: 20px;
    background-color: transparent;
    border-style: none;
    width: 20px;
    height: 15px;
    padding: 0;
    outline: none;
  }
  #screen{
    position: absolute;
    top: 210px;
    width: 20%;
    min-width: 290px;
    max-width: 350px;
    left: 60%;
    height: 100%;
  }
  #screen >>> h3{
    font-size: 20px;
    margin-bottom: 10px;
  }

  #eve1{
    position: absolute;
    width: 100%;
    top: 0px;
  }
  #eve2{
    position: absolute;
    width: 100%;
    top: 210px;
  }
  #eve3{
    position: absolute;
    width: 100%;
    top: 0;
  }
  #eve4{
    position: absolute;
    width: 100%;
    top: 250px;
  }
  #eve5{
    position: absolute;
    width: 100%;
    top: 110px;
  }
  #eve6{
    position: absolute;
    width: 100%;
    top: 300px;
  }
    @media screen and (max-width:950px) {
      table{
        width: 100%;
        margin-left: auto;
        border-style: none;
      }
      table tr td{
        padding: 10px 30px;
      }
      .time{
        border-left-style: none;
      }
      .event{
        border-right-style: none;
      }
      button{
        position: static;
      }
      img{
        transform: rotate(90deg);
      }
      #screen{
        position: relative;
        top: 0;
        left: auto;
        padding-top: 100px;
        margin-right: auto;
        margin-left: auto;
        width: 60%;
      }
      #eve1, #eve2, #eve3, #eve4, #eve5, #eve6{
        position: relative;
        top: 0;
      }
    }
      @media screen and (min-width: 1100px){
        .program {
          width: 1100px;
          padding-left: calc(50% - 550px);
          padding-right: calc(50% - 550px);
      }
    }
</style>

<script>
  import Title from '../components/Title.vue'

  export default{
    name: 'Program',
    components:{
      Title
    },
    data: function(){
        return{
          show1: false,
          show2: false,
          show3: false,
          show4: false,
          show5: false,
          show6: false,
        }
      },
    methods:{
      click1: function(){
        this.show1 = true
        this.show2 = false
        this.show3 = false
        this.show4 = false
        this.show5 = false
        this.show6 = false
        const wS = window.innerWidth
        if(wS < 950){
          const target = document.getElementById('screen')
          const rect = target.getBoundingClientRect()
          const currentScrolledHeight = window.pageYOffset || document.documentElement.scrollTop
          window.scrollTo({
            top: rect.top + currentScrolledHeight,
            behavior: "smooth"
          })
        }
      },
      click2: function(){
        this.show1 = false
        this.show2 = true
        this.show3 = false
        this.show4 = false
        this.show5 = false
        this.show6 = false
        const wS = window.innerWidth
        if(wS < 950){
          const target = document.getElementById('screen')
          const rect = target.getBoundingClientRect()
          const currentScrolledHeight = window.pageYOffset || document.documentElement.scrollTop
          window.scrollTo({
            top: rect.top + currentScrolledHeight,
            behavior: "smooth"
          })
        }
      },
      click3: function(){
        this.show1 = false
        this.show2 = false
        this.show3 = true
        this.show4 = false
        this.show5 = false
        this.show6 = false
        const wS = window.innerWidth
        if(wS < 950){
          const target = document.getElementById('screen')
          const rect = target.getBoundingClientRect()
          const currentScrolledHeight = window.pageYOffset || document.documentElement.scrollTop
          window.scrollTo({
            top: rect.top + currentScrolledHeight,
            behavior: "smooth"
          })
        }
      },
      click4: function(){
        this.show1 = false
        this.show2 = false
        this.show3 = false
        this.show4 = true
        this.show5 = false
        this.show6 = false
        const wS = window.innerWidth
        if(wS < 950){
          const target = document.getElementById('screen')
          const rect = target.getBoundingClientRect()
          const currentScrolledHeight = window.pageYOffset || document.documentElement.scrollTop
          window.scrollTo({
            top: rect.top + currentScrolledHeight,
            behavior: "smooth"
          })
        }
      },
      click5: function(){
        this.show1 = false
        this.show2 = false
        this.show3 = false
        this.show4 = false
        this.show5 = true
        this.show6 = false
        const wS = window.innerWidth
        if(wS < 950){
          const target = document.getElementById('screen')
          const rect = target.getBoundingClientRect()
          const currentScrolledHeight = window.pageYOffset || document.documentElement.scrollTop
          window.scrollTo({
            top: rect.top + currentScrolledHeight,
            behavior: "smooth"
          })
        }
      },
      click6: function(){
        this.show1 = false
        this.show2 = false
        this.show3 = false
        this.show4 = false
        this.show5 = false
        this.show6 = true
        const wS = window.innerWidth
        if(wS < 950){
          const target = document.getElementById('screen')
          const rect = target.getBoundingClientRect()
          const currentScrolledHeight = window.pageYOffset || document.documentElement.scrollTop
          window.scrollTo({
            top: rect.top + currentScrolledHeight,
            behavior: "smooth"
          })
        }
      }
    }
    }
</script>
